import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/selectionSummary/styles.scss';export default {
  "selectionSummary": "_selectionSummary_1jsob_1",
  "button": "_button_1jsob_8",
  "selectionSummaryEmpty": "_selectionSummaryEmpty_1jsob_18"
};